export const normalizeString = (str) => {
  return str.toLowerCase().replace(/[\s.']/g, '')
}

export const styleClass = (item) => {
  switch (item) {
    case 'Common':
      return 'common'
    case 'Uncommon':
      return 'uncommon'
    case 'Rare':
      return 'rare'
    case 'Ultra Rare':
      return 'ultra-rare'
    case 'Available':
      return 'available'
    case 'Unavailable':
      return 'unavailable'
    case 'Not Available':
      return 'unavailable'
    default:
      return ''
  }
}

export const toggleSelection = (array, value, setter) => {
  setter(
    array.includes(value) ? array.filter((v) => v !== value) : [...array, value]
  )
}
